<template>
	<div>
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit" @exportFile="exportFile" @BillInvoice="BillInvoice"></searchForm>
		<Table @on-selection-change="selectChangeList" :columns="columns1" :data="data" :height="tableHeight" ref="tableData"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getInvoiceInfoUrl" @listData='getDeviceData'></MyPage>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import searchForm from './Template/InvoiceInfoForm.vue';
	import infoModal from './Template/InvoiceInfoModal.vue';
	import expandRow from './Template/InvoiceInfoExpand.vue';
	import webapi from '../../../webapi.js';
	export default {
		components: {
			searchForm,
			infoModal
		},
		data() {
			return {
				getInvoiceInfoUrl: webapi.base_api_url + '/Order/GetInvoiceInfo',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['订单管理', '>>', '发票管理'],

				//开票订单id数组
				selectedListId: [],
				//开票订单号数组
				selectedListOrder: [],
				//开票订单总结算金额
				CouponCostAll: 0,
				//table标题数据
				columns1: [{
					type: 'expand',
					width: 30,
					render: (h, params) => {
						const _this = this
						return h(expandRow, {
							props: {
								row: params.row.Orders
							},
						})
					}
				}, {
					title: '申请开票时间',
					key: 'ApplyTime',
					minWidth: 120
				}, {
					title: '抬头名称',
					key: 'TitleName',
					minWidth: 180
				}, {
					title: '纳税人识别号',
					key: 'TitleIdentityNumber',
					minWidth: 120
				}, {
					title: '地址',
					key: 'TitleAddress',
					minWidth: 200
				}, {
					title: '开户银行',
					key: 'TitleBank',
					minWidth: 100
				}, {
					title: '开户银行账户',
					key: 'TitleBankAccount',
					minWidth: 120
				}, {
					title: '注册电话',
					key: 'TitleTelephone',
					minWidth: 120
				}, {
				// 	title: '发票类型',
				// 	key: 'InvoiceTypeDesc',
				// 	minWidth: 100
				// }, {
					title: '发票状态',
					key: 'InvoiceStatusDesc',
					minWidth: 100,
				}, {
					title: '充电电量(度)',
					key: 'ChargeKwh',
					width: 100,
				}, {
					title: '开票金额(元)',
					key: 'InvoiceAmount',
					width: 100,
				}, {
					title: '充电电费(元)',
					key: 'InvoiceAmountElec',
					width: 100,
				}, {
					title: '充电服务费(元)',
					key: 'InvoiceAmountService',
					width: 100,
				}, {
					title: '税点金额(元)',
					key: 'TaxPointAmount',
					width: 100,
				}, {
					title: '税点电费(元)',
					key: 'TaxPointAmountElec',
					width: 100,
				}, {
					title: '税点服务费(元)',
					key: 'TaxPointAmountService',
					width: 100,
				}, {
					title: '发票代码',
					key: 'InvoiceCode',
					minWidth: 100
				}, {
					title: '发票号码',
					key: 'InvoiceNumber',
					minWidth: 100
				}, {
					title: '接收邮箱',
					key: 'Email',
					minWidth: 100
				}, {
					// 	title: '接收地址',
					// 	key: 'MailingAddress',
					// }, {
					// 	title: '接收人',
					// 	key: 'MailingReceiver',
					// 	minWidth: 100
					// }, {
					title: '接收号码',
					key: 'PhoneNo',
					minWidth: 100
				}, {
					title: '所属场站',
					key: 'StationName',
					minWidth: 200,
				}, {
					title: '操作人',
					key: 'OperatorName',
					minWidth: 100
				}, {
					title: '操作时间',
					key: 'OperateTime',
					minWidth: 120
				}, {
					// 	title: '拒绝理由',
					// 	key: 'RejectReason',
					// 	minWidth: 200,
					// }, {
					title: '操作',
					key: 'action',
					minWidth: 150,
					align: 'center',
					render: (h, params) => {
						return h('div', [
							this.hasWidgets('makeInvoice') ? h('Button', {
								props: {
									type: 'primary',
									size: 'small',
									// disabled: params.row.InvoiceStatus == 2, // 已开票，则禁用按钮
								},
								style: {
									marginRight: '5px'
								},
								on: {
									click: () => {
										this.show("add", params.row)
									}
								}
							}, '开票') : h(),
							// h('Button', {
							// 	props: {
							// 		type: 'primary',
							// 		size: 'small'
							// 	},
							// 	style: {
							// 		marginRight: '5px'
							// 	},
							// 	on: {
							// 		click: () => {
							// 			// this.show("view", params.row)
							// 		}
							// 	}
							// }, '拒绝开票'),
						]);
					}
				}, ],
				data: [],
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},

		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			exportFile: function() {
				this.$refs.tableData.exportCsv({
					filename: '发票记录',
					columns: this.columns1,
					data: this.data.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						k.RefundTime = '\t' + (k.RefundTime || '');
						k.TitleBankAccount = '\t' + (k.TitleBankAccount || '');
						k.TitleIdentityNumber = '\t' + (k.TitleIdentityNumber || '');
						return k;
					})
				})
			},
			//开票多选
			selectChangeList: function(orderList) {
				const _this = this
				_this.CouponCostAll = 0
				_this.selectedListId = orderList.map(function(order) {
					console.log(order.Id);
					_this.CouponCostAll += order.CouponCost
					return order.Id;
				})
				_this.selectedListOrder = orderList.map(function(order) {
					return order.OrderNo;
				})
			},

			/******************组件固定方法*************************/
			show: function(type, params) {
				// if (this.selectedListId.length == 0) {
				// 	this.$Message.error("请最少选择一个开票订单")
				// } else {
				// let param = {
				// 	Id: this.selectedListId,
				// 	CouponCost: this.CouponCostAll,
				// 	selectedListOrder: this.selectedListOrder.toString()
				// }
				let param = {
					Id: params.Id,
					InvoiceAmount: params.InvoiceAmount,
				}
				this.$refs.ItemModal.show(type, param)
				// }
			},

			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			BillInvoice: function() {
				this.show('add', '开票')
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220 - (window.innerWidth < 1368 ? 60 : 0);
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
